import { render, staticRenderFns } from "./ReplayTestResultsButton.vue?vue&type=template&id=53e713a2&"
import script from "./ReplayTestResultsButton.vue?vue&type=script&lang=js&"
export * from "./ReplayTestResultsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports